import React from 'react';
import { useSelector } from 'react-redux';

import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import {
    DataTableContainer,
    MainContainerItems,
    LotSerial,
    LotSerialValue,
} from 'src/pages/orders/components/orderDetails/shipAndTrack/ShipAndTrack.styled';
import { Title } from 'src/pages/orders/components/orderDetails/replenRequest/ReplenRequest.styled';
import {
    HeaderData,
    DemiText,
} from 'src/common/refactoredComponents/dataTable/DataTable.styled';
import { MobileView, DesktopView } from 'src/pages/orders';
import { SetCount } from 'src/common/organisms/setsanditems/SetsAndItems.styled';
import { Type } from 'src/pages/orders/components/orderDetails/billingSummary/adjustments/Adjustments.styled';
import Highlighter from 'react-highlight-words';
import { setItemsDataHandler, logErrorToConsole } from 'src/utils/util';
import {
    ShippedQty,
    Subtitle,
} from 'src/pages/orders/components/orderDetails/shipAndTrack/ShipAndTrack.styled';
import { isMobileDevice, capitalizeText } from 'src/utils/util';
import { ShipTrackLabels } from 'src/constants/orderListConstants';

const ItemsInShipment = (props) => {
    const {
        productsDetails,
        searchText,
        handleSetItemClick,
        ordersList,
        isOrderType,
        isConsignmentReturn,
    } = props;

    const setItemHandler = (data, orderList) => {
        const setItemDetails = setItemsDataHandler(data, orderList);
        handleSetItemClick(setItemDetails);
    };

    const textHighlightedWords = (data) => {
        return (
            <Highlighter
                searchWords={searchText}
                autoEscape={true}
                textToHighlight={data}
            />
        );
    };
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );

    const isMobile = isMobileDevice();

    let colData = [
        {
            field: 'sets/items',
        },
        {
            field: 'Quantity',
        },
    ];

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        };
        switch (column.field) {
            case 'sets/items':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>
                            {textHighlightedWords(
                                ShipTrackLabels()['productItemDescriptionLabel']
                            )}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: isMobile
                        ? isOrderType
                            ? '0.5rem 0rem 0.5rem 1rem'
                            : '0.5rem 0rem 0.5rem 0.5rem'
                        : '0.5rem 0rem 0.5rem 1rem',
                    width: '70%',
                };
                extraProps.bodyStyle = {
                    padding: isMobile
                        ? isOrderType
                            ? '0rem 0rem 0rem 1rem'
                            : '0rem 0rem 0rem 0.5rem'
                        : '0rem 0rem 0rem 1rem',
                    width: '70%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems
                            height={'80%'}
                            smPadding={'0px'}
                            width={'100%'}
                            mbHeight={'unset'}
                        >
                            {rowData?.cfn ? (
                                <Title
                                id={`orders-shipandtrack-itemsinshipment-item-${rowData?.cfn || 'unknown'}-title`}
                                    onClick={() => {
                                        try {
                                        setItemHandler(rowData, ordersList);
                                        } catch (error) {
                                          logErrorToConsole(error);
                                        }
                                    }}
                                    marginBottom={'5px'}
                                    cursor={'pointer'}
                                >
                                    {textHighlightedWords(rowData.cfn)}
                                </Title>
                            ) : (
                                <Title></Title>
                            )}

                            <Subtitle width="100%">
                                {rowData?.description
                                    ? textHighlightedWords(
                                          capitalizeText(rowData.description)
                                      )
                                    : null}
                                {(isConsignmentReturn || isOrderType) &&
                                rowData?.serialNumber ? (
                                    <>
                                        <LotSerial>
                                            {textHighlightedWords(
                                                ShipTrackLabels().lotLabel
                                            )}{' '}
                                            <LotSerialValue>
                                                {textHighlightedWords(
                                                    rowData.serialNumber
                                                )}
                                            </LotSerialValue>
                                        </LotSerial>
                                    </>
                                ) : null}
                            </Subtitle>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'Quantity':
                extraProps.header = (
                    <HeaderData>
                        <DesktopView>
                            <DemiText>
                                {textHighlightedWords(
                                    ShipTrackLabels()['productQuantityLabel']
                                )}
                            </DemiText>
                        </DesktopView>
                        <MobileView>
                            <DemiText>
                                {textHighlightedWords(
                                    ShipTrackLabels()['mobileProductQtyLabel']
                                )}
                            </DemiText>
                        </MobileView>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: isMobile
                        ? isOrderType
                            ? '0.5rem 1rem 0.5rem 0rem'
                            : '0.5rem 0.5rem 0.5rem 0rem'
                        : '0.5rem 1rem 0.5rem 0rem',
                    width: '30%',
                    textAlign: 'end',
                };
                extraProps.bodyStyle = {
                    padding: isMobile
                        ? isOrderType
                            ? '0rem 1rem 0rem 0rem'
                            : '0rem 0.5rem 0rem 0rem'
                        : '0rem 1rem 0rem 0rem',
                    width: '30%',
                    textAlign: 'end',
                };
                extraProps.body = (rowData) => {
                    return (
                        <ShippedQty>
                            <SetCount fontSize={'16px'}>
                                {rowData?.quantity
                                    ? textHighlightedWords(
                                          `${rowData.quantity} x`
                                      )
                                    : null}

                                <Type>
                                    {textHighlightedWords(
                                        orderBasicDetails?.currentOrderType ===
                                            'ZOR' ||
                                            orderBasicDetails?.currentOrderType ===
                                                'KE' ||
                                            orderBasicDetails?.currentOrderType ===
                                                'ZKA' ||
                                            orderBasicDetails?.currentOrderType ===
                                                'KB'
                                            ? ShipTrackLabels()['eaLabel']
                                            : rowData?.isSet
                                            ? ShipTrackLabels()['setLabel']
                                            : ShipTrackLabels()['eaLabel']

                                        // rowData?.isSet
                                        //     ? ShipTrackLabels()['setLabel']
                                        //     : rowData.uom
                                    )}
                                </Type>
                            </SetCount>
                        </ShippedQty>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    return (
        <DataTableContainer>
            <Datatable
                id={'orders-orderDetails-shipAndTrack-itemsInShipment'}
                backgroundColorOdd={'#F5F5F599'}
                backgroundColorEven={'#FFFFFF99'}
                headerBorderBottom={'1.4px solid #dcdcdc'}
                resizableColumns
                columns={colData}
                data={productsDetails}
                scrollable
                rows={productsDetails?.length > 0 ? productsDetails.length : 0}
            />
        </DataTableContainer>
    );
};

export default ItemsInShipment;
